import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function CostComparison() {
  const comparisonRows = [{
    sin: 'Preparás clases sin material argentino',
    perdes: 'Horas de búsqueda que terminan en nada útil'
  }, {
    sin: 'Sin actividades listas',
    perdes: 'Domingos a la noche improvisando para el lunes'
  }, {
    sin: 'Sin evaluaciones preparadas',
    perdes: 'Tiempo valioso que podrías usar en otras cosas'
  }, {
    sin: 'Sin casos reales argentinos',
    perdes: 'Alumnos desconectados que no ven la relevancia'
  }, {
    sin: 'Sin planificación anual',
    perdes: 'Año lectivo sin estructura ni coherencia'
  }, {
    sin: 'Sin proyectos para ferias',
    perdes: 'Oportunidades de aprendizaje profundo que no ocurren'
  }, {
    sin: 'Sin el Atlas Hidrológico',
    perdes: 'Clases sin recursos visuales que anclen los conceptos'
  }, {
    sin: 'Sin conexión con los NAP',
    perdes: 'Planificaciones que no justifican los contenidos'
  }];
  return <section className="py-20 bg-[#0f1d35] text-white" data-id="element-18">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="bg-[#0a1428]/60 rounded-2xl p-6 md:p-10 border border-slate-500/30 mb-12 max-w-3xl mx-auto" data-id="element-22">
          <div className="grid grid-cols-2 gap-4 mb-6 pb-4 border-b border-slate-500/30" data-id="element-23">
            <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-24">
              Sin el Megapack
            </div>
            <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-25">
              Lo que realmente perdés
            </div>
          </div>
          <ul className="space-y-6" data-id="element-26">
            {comparisonRows.map((row, i) => <li key={i} className="grid grid-cols-2 gap-4 items-center" data-id="element-27">
                <div className="flex items-start gap-3" data-id="element-28">
                  <div className="mt-1 bg-slate-700/50 p-1 rounded-full shrink-0 border border-slate-500/50" data-id="element-29">
                    <X className="w-4 h-4 text-slate-400" data-id="element-30" />
                  </div>
                  <span className="text-slate-300 text-sm md:text-base" data-id="element-31">
                    {row.sin}
                  </span>
                </div>
                <div className="text-red-300/90 text-sm md:text-base font-medium" data-id="element-32">
                  {row.perdes}
                </div>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-br from-[#0f1d35] to-[#1e3a5f] rounded-2xl p-8 md:p-12 shadow-2xl border border-slate-400/30" data-id="element-33">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-34">
            💧🇦🇷 "La próxima clase que des sobre el agua podés hacerla con datos
            argentinos reales, actividades listas y evaluaciones preparadas. O
            podés seguir buscando en Google lo que nunca termina de aparecer."
          </p>
        </motion.div>
      </div>
    </section>;
}